var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlassImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120,620.75C970.2,607.32,808.56,600,640,600s-330.2,7.32-480,20.75q-19.27,1.72-38.29,3.58A64,64,0,0,0,64,688V800c0,150.22,16,256,272,256,169.7,0,251.9-100,268.7-211.61a144.12,144.12,0,0,1,70.6,0C692.1,956,774.3,1056,944,1056c256,0,272-105.78,272-256V688a64,64,0,0,0-57.71-63.7Q1139.28,622.47,1120,620.75ZM336,960c-51.42,0-92-4.75-120.66-14.12-26-8.51-33.71-18.16-36.23-21.34C161.48,902.4,160,848.64,160,800V717.11c112.48-10.27,230.69-16.92,352-19.66V800c0,44.39-13.77,83.86-38.77,111.13C443.51,943.56,397.34,960,336,960ZM608,752V696.09q16-.09,32-.09t32,.09V752Zm512,48c0,48.64-1.48,102.4-19.11,124.54-2.52,3.18-10.21,12.83-36.23,21.34C1036,955.25,995.42,960,944,960c-61.34,0-107.51-16.44-137.23-48.87C781.77,883.86,768,844.39,768,800V697.45c121.31,2.74,239.52,9.39,352,19.66Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.87,531c12.9-1.27,26-2.5,39-3.66q25.2-2.26,50.7-4.27L345.94,264.33a16,16,0,0,1,14-8.27h58.13A32,32,0,0,0,450,224V192a32,32,0,0,0-31.95-32H359.92A111.81,111.81,0,0,0,262,217.93L88,536A159.94,159.94,0,0,1,114.87,531Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.13,531c-12.9-1.27-26-2.5-39-3.66q-25.2-2.26-50.7-4.27L958.06,264.33a16,16,0,0,0-14-8.27H886a32,32,0,0,1-32-32V192a32,32,0,0,1,32-32h58.13A111.81,111.81,0,0,1,1042,217.93L1216,536A159.94,159.94,0,0,0,1189.13,531Z",
    style: {
      fill: "#282828"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassImageNormal);
export default __webpack_public_path__ + "static/media/glass_image_normal.4fae0600f83f9a9a5abf58b1578766d0.svg";
export { ForwardRef as ReactComponent };